import React from "react";
import { CalendarIcon, PhoneCallIcon, UsersIcon } from "lucide-react";
import { Link } from "react-router-dom";

export default function HelpSection() {
  const helpCards = [
    {
      icon: <CalendarIcon size={40} className="text-amber-500 mb-4" />,
      title: "APPLY FOR A LOAN",
      description:
        "Have an emergency or looking to buy a car? Apply for a loan now.",
      action: "Get Appointment",
      link: "/apply-loan",
    },
    {
      icon: <PhoneCallIcon size={40} className="text-amber-500 mb-4" />,
      title: "CALL US AT",
      description: (
        <>
          <p className="text-amber-500 font-semibold text-lg">
            0740000077/0108555888
          </p>
          <p className="text-sm text-gray-600">info@bundainvestment.com</p>
        </>
      ),
      action: "Contact Us",
      link: "/contact-us",
    },
    {
      icon: <UsersIcon size={40} className="text-amber-500 mb-4" />,
      title: "CALL US",
      description: "Need loan advice? Talk to our loan advisors.",
      action: "Meet an Advisor",
      link: "/contact-us",
    },
  ];

  return (
    <section className="bg-gray-100 py-16 px-6 text-center font-serif">
      <h2 className="text-3xl font-semibold text-gray-800 mb-2">
        We are Here to Help You
      </h2>
      <p className="text-gray-500 mb-10">
        Our mission is to deliver quick, reliable access to cash.
      </p>

      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {helpCards.map((card, index) => (
          <div
            key={index}
            className="bg-white shadow-md p-8 rounded-lg text-center hover:shadow-lg transition duration-300"
          >
            {card.icon}
            <h3 className="text-md font-bold text-gray-800 mb-2">
              {card.title}
            </h3>
            <div className="text-sm text-gray-600 mb-4">{card.description}</div>
            <Link
              to={card.link}
              className="text-amber-500 font-semibold border-b-2 border-amber-300 hover:text-blue-600 transition"
            >
              {card.action}
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
